import React, {useState, useEffect, Fragment} from 'react'
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Slider from "react-slick";
import { Link as RouterLink } from 'react-router-dom';
import Wave from 'react-wavify';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { Button, CardActions, Chip, Divider, Paper, Stack, useTheme, alpha } from '@mui/material';
import { useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import CardHeader from '@mui/material/CardHeader';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ListItemButton from '@mui/material/ListItemButton';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SavingsIcon from '@mui/icons-material/Savings';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import apiClient from "../../request/http-common";
import { useMutation } from "react-query";
import { useNavigate } from 'react-router-dom';
import { setInvestments } from '../../request/Analysis/hitorySlice';
import { useDispatch } from 'react-redux';
import { Currency } from '@depay/local-currency';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useParams } from 'react-router-dom';


// for new payment method
import { QRCode } from 'react-qrcode-logo';
import TextField from '@mui/material/TextField';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import SmallChart from '../Traders/SmallChart';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CategoryPlans = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const coinRates = useSelector((state) => state.coins.coinRates);
  const fundings = useSelector((state) => state.wallet.fundings);
  const tradings = useSelector((state) => state.history.tradings);
  const addresses = useSelector((state) => state.coins.addresses);

  const params = useParams();

  
  const calculateBalance = (coin) => {
    let amount = 0;
    fundings.forEach(fund => {
      if (fund.gateway === coin) {
        amount += parseFloat(fund.amount);
      }
      });

      tradings.forEach(trade => {
        if (trade.pair === coin) {
          amount += parseFloat(trade.profit);
        }
        });

    
      return amount;
  }

  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = useState(0);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  const navigate = useNavigate();
  const plans = useSelector((state) => state.plans.plans);
  const categories = useSelector((state) => state.plans.categories);
  const user = useSelector((state) => state.user.user);

    const fundingBal = useSelector((state) => state.wallet.fundingBalance);
    const subBal = useSelector((state) => state.wallet.subscriptionBalance);
    const refBal = useSelector((state) => state.wallet.referralBalance);
    const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  const dispatch = useDispatch();
  const [rate, setRate] = useState(1);

  const callRate = async()=> {
    if(user.currency === 'USD'){
      setRate(1);
    }else{
      await Currency.fromUSD({ amount: 1 }).then(amount=>{
        setRate(amount.amount);
       });
    }  
};


    const setcategories = (number_of_downlines, total_earning, initial_earning) => {
        const categories = [];
        for (let i = 0; i <= parseInt(number_of_downlines); i++) {
            let heads = '';
            for (let j = 1; j <= i; j++) {
                heads += '🙂';
            }

            if (i === 0) {
              const initialPercentage = (parseInt(initial_earning) / parseInt(total_earning))*100;
                categories.push('INITIAL ROI = '+initialPercentage.toFixed(2)+'%');
            }else if (i === parseInt(number_of_downlines)) {
                categories.push('STAGE '+i +' = ' + heads+ '' );
            } else {
                categories.push('STAGE '+i +' = ' + heads);
            }
            
        }
        return categories;
    }

    const setAmounts = (initial_earning, total_earning, number_of_downlines, bonus_per_downline, amount_invested) => {

      const initialPercentage = (parseInt(initial_earning) / parseInt(total_earning))*100;
      const amounts = [initialPercentage.toFixed(2)];
      
      for (let downlines = 1; downlines <= parseInt(number_of_downlines); downlines++) {
        amounts.push(parseInt(bonus_per_downline * downlines))
      }
        

        return amounts;

    }

    const [planId, setPlanId] = useState();
    const [selectedPlan, setSelectedPlan] = useState('');
    const [source, setSource] = useState('');
    const [currentDuration, setCurrentDuration] = useState('');
    const [convertedAmount, setConvertedAmount] = useState(0);
    const [error, setErros] = useState('');


     // for new balance method
     const [buttonText, setbuttonText] = useState(null);
     const [selectedCoin, setSelectedCoin] = useState(null);
 
     const getCoinDetails = (coinName) => {
       switch (coinName) {
         case 'Overall Asset':
           setSelectedCoin(null) 
           break;
 
         case 'Referral Wallet':
           setSelectedCoin(null) 
           break;
       
         default:
           addresses.forEach(address => {
             if (address.coin_name === coinName) {       
               setSelectedCoin(address)            
             }
           });
           break;
       }
     }

    const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
        async () => {
          return await apiClient.post(`/api/invest`, {
            investment_plan_id: planId,
            amount: amount, 
            rate: rate,
            duration: currentDuration,
            payment_source: source
          });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
                dispatch(setInvestments(res.data.investments));
                setTimeout(() => {
                  navigate('/investments');
                }, 2000);
              }            
          },
          onError: (err) => {
                // let errorMessage = err.response?.data.message || err ;

                // localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                // const event = new Event('newMessage');
                // window.dispatchEvent(event);

                if (err.response?.data.length) {
                  let myerror = err.response?.data || err;         
              setErros(myerror.errors)               
              }else{
                  let errorMessage = err.response?.data.message || err ;
                  localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
              }
          },
        }
      );

      
      useEffect(() => {
        callRate();
      }, []);

  return (
    <div style={{backgroundColor: 'transparent'}}>
    <Typography mb={-8} mt={4} px={3} sx={{ marginTop: '75px', fontWeight: 'bold', fontSize: 20, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
        {params.id}
    </Typography>
    <Typography mb={1}  mt={8} px={3} sx={{  textAlign: 'center', fontSize: 14  }} variant="subtitle1" gutterBottom>
       
       {categories.map(category =>(
        category.name === params.id &&
        category.description
       ))} 
      </Typography>

      {plans.length > 0 &&
        <Grid container px={2} mt={4} mb={4} rowSpacing={3} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
      {plans.map(plan =>(
        
        plan.category.name === params.id &&
        <Grid key={plan.id} item xs={12} md={6} lg={4} sx={{bgcolor: 'transparent', display: 'flex'}}>
            <Card 
              className='box'  
              sx={{
                marginTop: '0px', 
                marginBottom: '0px',
                borderRadius: 3,
                overflow: 'hidden',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                background: isDarkMode 
                  ? 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
                  : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                border: isDarkMode 
                  ? '1px solid rgba(255,255,255,0.1)'
                  : '1px solid rgba(0,0,0,0.08)',
                boxShadow: isDarkMode
                  ? '0 8px 32px rgba(0,0,0,0.3)'
                  : '0 8px 32px rgba(0,0,0,0.1)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: isDarkMode
                    ? '0 20px 40px rgba(0,0,0,0.4)'
                    : '0 20px 40px rgba(0,0,0,0.15)',
                }
              }} 
              elevation={0}
            >
              <CardContent sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Header Section */}
                <Box sx={{ mb: 2 }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 1 }}>
                    <Typography variant="h5" sx={{ 
                      fontWeight: 700, 
                      color: theme.palette.text.primary,
                      fontSize: '1.25rem',
                      lineHeight: 1.2
                    }}>
                      {plan.name}
                    </Typography>
                    {plan.investment_type && (
                      <Chip 
                        label={plan.investment_type} 
                        size="small" 
                        sx={{ 
                          bgcolor: isDarkMode ? alpha(theme.palette.primary.main, 0.2) : '#e6fffa',
                          color: isDarkMode ? theme.palette.primary.light : '#065f46',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          height: 24
                        }} 
                      />
                    )}
                  </Stack>
                </Box>

                {/* Description Section */}
                {plan.description && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ 
                      color: theme.palette.text.secondary, 
                      lineHeight: 1.6,
                      fontSize: '0.875rem'
                    }}>
                      {plan.description}
                    </Typography>
                  </Box>
                )}

                {/* Key Metrics */}
                <Box sx={{ mb: 3, flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ 
                        p: 2, 
                        bgcolor: isDarkMode ? alpha(theme.palette.background.paper, 0.5) : '#f7fafc', 
                        borderRadius: 2,
                        border: isDarkMode ? `1px solid ${alpha(theme.palette.divider, 0.1)}` : '1px solid #e2e8f0'
                      }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <MonetizationOnIcon sx={{ color: theme.palette.primary.main, fontSize: 20 }} />
                          <Box>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                              Investment Range
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                              {formatPrice(plan.min_amount)} - {parseInt(plan.amount_invested) >= 1000000 ? 'UNLIMITED' : formatPrice(plan.amount_invested)}
                            </Typography>
                          </Box>
                        </Stack>
                      </Paper>
                    </Grid>
                    
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{ 
                        p: 2, 
                        bgcolor: isDarkMode ? alpha(theme.palette.success.main, 0.1) : '#f0fdf4', 
                        borderRadius: 2,
                        border: isDarkMode ? `1px solid ${alpha(theme.palette.success.main, 0.2)}` : '1px solid #bbf7d0'
                      }}>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <TrendingUpIcon sx={{ color: theme.palette.success.main, fontSize: 20 }} />
                          <Box>
                            <Typography variant="caption" sx={{ color: theme.palette.success.dark, display: 'block' }}>
                              Expected Returns
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.success.main }}>
                              {plan.min_return_percentage && plan.max_return_percentage
                                ? `${plan.min_return_percentage}% - ${plan.max_return_percentage}%`
                                : `${parseFloat(plan.total_earning).toFixed(2)}%`}
                            </Typography>
                          </Box>
                        </Stack>
                      </Paper>
                    </Grid>
                  </Grid>
                </Box>

                {/* Duration and Additional Info */}
                <Box sx={{ mb: 3 }}>
                  <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <ScheduleIcon sx={{ color: theme.palette.info.main, fontSize: 18 }} />
                      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
                        {plan.investment_duration_range || plan.duration}
                      </Typography>
                    </Stack>
                    
                    {plan.min_additional_investment && (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <SecurityIcon sx={{ color: theme.palette.warning.main, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
                          Min Add: {formatPrice(plan.min_additional_investment)}
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Box>

                {/* Holdings Allocation Preview */}
                {plan.holdings_allocation && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ 
                      color: theme.palette.text.primary, 
                      fontWeight: 600, 
                      mb: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1
                    }}>
                      <Diversity3Icon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
                      Top Holdings
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {Object.entries(JSON.parse(plan.holdings_allocation)).slice(0, 3).map(([key, value]) => (
                        <Chip 
                          key={key}
                          label={`${key}: ${value}`}
                          size="small"
                          variant="outlined"
                          sx={{ 
                            fontSize: '0.7rem',
                            height: 24,
                            borderColor: theme.palette.divider,
                            color: theme.palette.text.secondary
                          }}
                        />
                      ))}
                      {Object.keys(JSON.parse(plan.holdings_allocation)).length > 3 && (
                        <Chip 
                          label={`+${Object.keys(JSON.parse(plan.holdings_allocation)).length - 3} more`}
                          size="small"
                          variant="outlined"
                          sx={{ 
                            fontSize: '0.7rem',
                            height: 24,
                            borderColor: theme.palette.divider,
                            color: theme.palette.text.secondary
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                )}

                <Divider sx={{ my: 2, borderColor: theme.palette.divider }} />

                {/* Action Button */}
                <Button 
                  onClick={() => {
                    handleClickOpen();
                    setPlanId(plan.id);
                    setSelectedPlan(plan);
                    setConvertedAmount(parseFloat(plan.amount_invested));
                  }}  
                  fullWidth 
                  variant="contained"
                  sx={{ 
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem',
                    py: 1.5,
                    borderRadius: 2,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
                    '&:hover': {
                      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.darker || theme.palette.primary.dark} 100%)`,
                      boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
                    }
                  }}
                >
                  {(isInvesting && planId === plan.id) ? 'Processing...' : 'Invest Now'}
                </Button>
              </CardContent>
            </Card>
        </Grid> 
      ))
      
    }
    </Grid>
      
      }


      
              
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
        sx={{
          zIndex: 1300, // Standard Material-UI modal z-index
          '& .MuiBackdrop-root': {
            zIndex: 1299,
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: isDarkMode 
              ? 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
              : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            boxShadow: isDarkMode
              ? '0 20px 60px rgba(0,0,0,0.4)'
              : '0 20px 60px rgba(0,0,0,0.15)',
            zIndex: 1300,
          }
        }}
      >
        <DialogTitle sx={{ 
          textAlign: 'center', 
          pb: 1,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: 'white',
          fontWeight: 700,
          fontSize: '1.25rem'
        }}>
          Invest Now
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>

         
          <Typography variant="body2" mt={2} sx={{ textAlign: 'center', mb: 3, color: theme.palette.text.secondary }}>
            Kindly enter any amount from {selectedPlan !== '' &&`
             ${formatPrice(selectedPlan.min_amount )} to  ${formatPrice(selectedPlan.amount_invested )} 
            `} to invest
          </Typography>
            {/* {istracking ? 'Tracking payment..., you will receive email and your account will be credited once your payment is confirmed. Thank you.': 

            `Kindly enter any amount in ${Currency.getCode()} and proceed to pay`
            } */}

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

            <FormControl fullWidth>
              <InputLabel htmlFor="amount" sx={{ color: theme.palette.text.secondary }}>Enter Amount</InputLabel>
              <OutlinedInput
                onChange={(e)=>setAmount(e.target.value)}
                id="amount"
                type={'number'}
                label="Enter Amount"
                sx={{
                  borderRadius: 2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.divider,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                  },
                }}
              />
            </FormControl>

            {(selectedPlan !== '' && selectedPlan.duration && selectedPlan.duration.split(',').length > 0) &&
                        <FormControl fullWidth>
                        <InputLabel htmlFor="duration" sx={{ color: theme.palette.text.secondary }}>Select Duration</InputLabel>
                        {(error !== '' && error.duration) ?
                        <Select
                        error
                        onChange={(e) => setCurrentDuration(e.target.value)}
                        labelId="duration"
                        id="duration"
                        name="duration"
                        label="Select Duration"
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              zIndex: 1400, // Higher than modal to appear above
                            }
                          }
                        }}
                        sx={{
                          borderRadius: 2,
                          zIndex: 1, // Ensure select is above backdrop
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#ef4444',
                          },
                        }}
                        >
                        <MenuItem selected value=''>
                            Select duration
                        </MenuItem> 
                        {selectedPlan.duration.split(',').map(duration =>(
                            <MenuItem key={duration.trim()} value={duration.trim()}>{duration.trim()}</MenuItem>
                        ))}             
                        
                    </Select>
                        :
                        <Select
                            onChange={(e) => setCurrentDuration(e.target.value)}
                            labelId="duration"
                            name="duration"
                            id="duration"
                            label="Select Duration"
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  zIndex: 1400, // Higher than modal to appear above
                                }
                              }
                            }}
                            sx={{
                              borderRadius: 2,
                              zIndex: 1, // Ensure select is above backdrop
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#d1d5db',
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#22c55e',
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#22c55e',
                                borderWidth: 2,
                              },
                            }}
                            >
                            <MenuItem selected value="">
                                Select duration
                            </MenuItem>              
                            {selectedPlan.duration.split(',').map(duration =>(
                            <MenuItem key={duration.trim()} value={duration.trim()}>{duration.trim()}</MenuItem>
                            ))}  
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.duration}
                        </Typography>
                    </FormControl>
                        }


                      <FormControl fullWidth>
                          <InputLabel htmlFor="source" sx={{ color: theme.palette.text.secondary }}>Select Payment Source</InputLabel>
                          {(error !== '' && error.source) ?
                          <Select
                          error
                          onChange={(e) => 
                                
                            {
                              setSource(e.target.value)
                              getCoinDetails(e.target.value)
                            }}
                          labelId="source"
                          id="source"
                          name="source"
                          label="Select Payment Source"
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                zIndex: 1400, // Higher than modal to appear above
                              }
                            }
                          }}
                          sx={{
                            borderRadius: 2,
                            zIndex: 1, // Ensure select is above backdrop
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#ef4444',
                            },
                          }}
                          >
                          <MenuItem selected value=''>
                          Select Gateway
                          </MenuItem> 

                          <MenuItem selected value="Overall Asset">
                          Overall Asset (Bal = {formatPrice(fundingBal)})
                          </MenuItem>

                          
                      </Select>
                          :
                          <Select
                          onChange={(e) => 
                                
                            {
                              setSource(e.target.value)
                              getCoinDetails(e.target.value)
                            }}
                              labelId="source"
                              name="source"
                              id="source"
                              label="Select Payment Source"
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    zIndex: 1400, // Higher than modal to appear above
                                  }
                                }
                              }}
                              sx={{
                                borderRadius: 2,
                                zIndex: 1, // Ensure select is above backdrop
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#d1d5db',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#22c55e',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#22c55e',
                                  borderWidth: 2,
                                },
                              }}
                              >
                              <MenuItem selected value=''>
                              Select Gateway
                              </MenuItem> 

                              <MenuItem selected value="Overall Asset">
                              Overall Asset (Bal = {formatPrice(fundingBal)})
                              </MenuItem> 

                              
                          </Select>
                          }
                          <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                          {error !== '' && error.source}
                          </Typography>
                      </FormControl>


                      {selectedCoin !== null &&
                      
                      <Fragment>
                        
                      <Alert severity="info">
                        
                      {selectedCoin.wallet_type === 'bank' ?
                        `Kindly make payment to our ${selectedCoin.coin_name} account using the details below`
                        : 
                        `Kindly send ${formatPrice(amount)} worth of ${selectedCoin.coin_name} to the provided address below.`
                      }
                        
                        
                        </Alert>                       
                      
                      {selectedCoin.wallet_type === 'Crypto' && 
                      <Box my={2} sx={{display: 'flex', justifyContent: 'center' }}>
                        <QRCode qrStyle="dots" value={selectedCoin.address} size={200}
                        logoImage={``}
                      />
                      </Box>
                        }

                            {/* <Box my={2} sx={{display: 'flex', justifyContent: 'center' }}>
                              <CircularProgress />           
                            </Box> */}
                            <Box my={2} sx={{display: 'flex', justifyContent: 'center' }}>
                          <CopyToClipboard onCopy={() => {setbuttonText(selectedCoin.wallet_type === 'bank'? 'Account Details Copied' : 'Address Copied');
                              setTimeout(() => {
                                  setbuttonText(null);
                              }, 2000);}} text={selectedCoin.address}>
                              <FormControl  fullWidth={true} sx={{ minWidth: 50, marginBottom: 2 }}>
                                  <TextField
                                  minRows={1} multiline
                                  
                                  defaultValue={selectedCoin.address}
                                  id="address"
                                  name="address"
                                  type={'text'}
                                  label= {buttonText !== null? buttonText: `Click to copy ${selectedCoin.coin_name} ${selectedCoin.wallet_type === 'bank'? 'bank details' : 'address'} address`}
                                  />
                              </FormControl> 
                          </CopyToClipboard>
                          </Box>
                      </Fragment>
                      }
          </Box> 

          <Button 
            onClick={postInvestment} 
            fullWidth 
            size="large" 
            variant="contained"
            sx={{ 
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1.1rem',
              py: 2,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
              '&:hover': {
                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.darker || theme.palette.primary.dark} 100%)`,
                boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
              }
            }}
          > 
            {isInvesting ? 'Processing Investment...' : 'Submit Investment Request'}  
          </Button>      
          
        </DialogContent>
        
      </Dialog>
    
</div>
  )
}

export default CategoryPlans
